export default __webpack_public_path__ + "static/media/wegzeit_fussweg.f1610004.svg";